export { default } from './LeilaoDeVeiculosConheca';
